__turbopack_context__.v({
  "chartColumn": "ScrollyPulse-module__hGkBDq__chartColumn",
  "flow": "ScrollyPulse-module__hGkBDq__flow",
  "gate": "ScrollyPulse-module__hGkBDq__gate",
  "home": "ScrollyPulse-module__hGkBDq__home",
  "parallax": "ScrollyPulse-module__hGkBDq__parallax",
  "parallax-drift": "ScrollyPulse-module__hGkBDq__parallax-drift",
  "rail": "ScrollyPulse-module__hGkBDq__rail",
  "railFill": "ScrollyPulse-module__hGkBDq__railFill",
  "stickyChart": "ScrollyPulse-module__hGkBDq__stickyChart",
  "stickyScope": "ScrollyPulse-module__hGkBDq__stickyScope",
  "topBlur": "ScrollyPulse-module__hGkBDq__topBlur",
});
